import { Draft, DraftState } from '@/types';
import { isDraftState } from '@/components/draft/draftState/actions/helper/isDraftState';
import { setValidationErrorFlag } from './setValidationErrorFlag';

export const removeConfiguration = (draft: Draft | DraftState, configurationId: number) => {
  delete draft.configurations[configurationId];
  draft.configurationIds.splice(draft.configurationIds.indexOf(configurationId), 1);

  if (isDraftState(draft)) {
    if (draft.selectedConfigurationId === configurationId) {
      draft.selectedConfigurationId = -1;
    }

    delete draft.validation.errors[configurationId];
    setValidationErrorFlag(draft);
  }
};
